import {
  FileTextOutlined,
  RiseOutlined,
  StarFilled,
  StarOutlined,
} from "@ant-design/icons";
import { PageHeader, Tabs, message } from "antd";
import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";

const { TabPane } = Tabs;

const COLORS = {
  creador:         "#722ED1",
  ventas:          "#00BFD6",
  compras:         "#2DB34A",
  inventario:      "#F07D2F",
  administrativos: "#5A4FCC",
  financieros:     "#1677FF",
  calidad:         "#EB2F96",
  fiscales:        "#CF1322",
  recursosHumanos: "#13A8A8",
  escuela:         "#9254DE",
};

const REPORT_COLORS = {
  "Ventas Generales":                                   COLORS.ventas,
  "Pedidos":                                            COLORS.ventas,
  "Cotizaciones":                                       COLORS.ventas,
  "Ventas Fiscales":                                    COLORS.ventas,
  "Insumos Más Vendidos":                               COLORS.ventas,
  "Margen De Ventas":                                   COLORS.ventas,
  "Notas De Credito Venta":                             COLORS.ventas,
  "Ventas Por Lote":                                    COLORS.ventas,
  "Cotizacion Vs Ventas":                               COLORS.ventas,
  "Pedido Vs Ventas":                                   COLORS.ventas,
  "Compras Generales":                                  COLORS.compras,
  "Ordenes de Compra":                                  COLORS.compras,
  "Requisiciones":                                      COLORS.compras,
  "Insumos Más Comprados":                              COLORS.compras,
  "Costos Internos":                                    COLORS.compras,
  "Comodatos":                                          COLORS.compras,
  "Notas De Credito Compra":                            COLORS.compras,
  "Insumos Y Proveedores":                              COLORS.compras,
  "Inventario Total":                                   COLORS.inventario,
  "Costo Inventario":                                   COLORS.inventario,
  "Costo Vs Ultima Compra":                             COLORS.inventario,
  "Insumos Y Equivalencias":                            COLORS.inventario,
  "Costo Produccion":                                   COLORS.inventario,
  "Entradas Y Salidas":                                 COLORS.inventario,
  "E. y S. Detallado":                                  COLORS.inventario,
  "Insumos No Inventariables":                          COLORS.inventario,
  "Resumen E. Y S.":                                    COLORS.inventario,
  "Recepciones Orden de Compra":                        COLORS.inventario,
  "Actividad Etapas":                                   COLORS.inventario,
  "Traspaso Entre Almacenes":                           COLORS.inventario,
  "Costo Total Proyecto":                               COLORS.inventario,
  "Taxidermia":                                         COLORS.inventario,
  "Insumos Pendientes":                                 COLORS.inventario,
  "Reporte De Lotes":                                   COLORS.inventario,
  "Cuentas Por Cobrar":                                 COLORS.administrativos,
  "Cuentas Por Pagar":                                  COLORS.administrativos,
  "Pagos":                                              COLORS.administrativos,
  "Ingresos":                                           COLORS.administrativos,
  "Presupuestos":                                       COLORS.administrativos,
  "Reposicion Caja Chica":                              COLORS.administrativos,
  "Cuentas Por Cobrar Agrupado":                        COLORS.administrativos,
  "Cuentas Por Pagar Agrupado":                         COLORS.administrativos,
  "Cuentas Cliente":                                    COLORS.administrativos,
  "Facturacion":                                         COLORS.administrativos,
  "Cobranza Por Semana":                                COLORS.administrativos,
  "Pagos a proveedores":                                COLORS.administrativos,
  "Reporte XML":                                        COLORS.administrativos,
  "Estado De Posicion Financiera":                      COLORS.financieros,
  "Estado De Resultados":                               COLORS.financieros,
  "Estado De Resultados Por Periodo":                   COLORS.financieros,
  "Estado De Cuenta":                                   COLORS.financieros,
  "Balanza De Comprobacion":                            COLORS.financieros,
  "Flujo De Efectivo":                                  COLORS.financieros,
  "Flujo De Efectivo Presupuestado":                    COLORS.financieros,
  "Flujo De Efectivo Diario":                           COLORS.financieros,
  "Libro Diario":                                       COLORS.financieros,
  "Libro Mayor":                                        COLORS.financieros,
  "Flujo De Tesorería":                                 COLORS.financieros,
  "Reporte Calidad":                                    COLORS.calidad,
  "Reporte DIOT":                                       COLORS.fiscales,
  "Balanza De Comprobacion - Contabilidad Electronica": COLORS.fiscales,
  "Reporte IVA":                                        COLORS.fiscales,
  "Retenciones De Compras":                             COLORS.fiscales,
  "Retenciones De Ventas":                              COLORS.fiscales,
  "Conciliacion Facturas Pagos":                        COLORS.fiscales,
  "Facturas Globales":                                  COLORS.fiscales,
  "Alumnos Y Ventas":                                   COLORS.escuela,
  "Referencias De Pago":                                COLORS.escuela,
};


function SectionHeader({ children, color }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        margin: "20px 0 0",
        paddingBottom: "8px",
        borderBottom: "1px solid #f0f0f0",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "4px",
          height: "18px",
          backgroundColor: color,
          borderRadius: "2px",
          flexShrink: 0,
        }}
      />
      <span
        style={{
          fontSize: "11.5px",
          fontWeight: 700,
          color: "#595959",
          letterSpacing: "0.07em",
          textTransform: "uppercase",
        }}
      >
        {children}
      </span>
    </div>
  );
}

class CardReportes extends Component {
  async onClickStar(e) {
    if (this.props.favorito) {
      await axios
        .post(
          "reportes/eliminarReporteFavorito",
          { reporte: e },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Eliminado de favorito");
          } else {
            message.error("Sucedio un error y no se pudo eliminar de favoritos");
          }
        });
    } else {
      await axios
        .post(
          "reportes/agregarReporteFavorito",
          { reporte: e },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Agregado a favorito");
          } else {
            message.error("Sucedio un error y no se pudo agregar a favoritos");
          }
        });
    }
  }

  render() {
    let clickstar = false;
    const color = this.props.color || "#00BFD6";
    const isFav = !!this.props.favorito;

    return (
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #e8e8e8",
          borderLeft: `4px solid ${color}`,
          borderRadius: "6px",
          padding: "12px 14px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          transition: "box-shadow 0.18s ease, transform 0.18s ease",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          minHeight: "50px",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.10)";
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.05)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
        onClick={() => {
          if (!clickstar) this.props.onClick();
        }}
      >
        <FileTextOutlined style={{ color, fontSize: "17px", flexShrink: 0 }} />
        <span
          style={{
            flex: 1,
            fontSize: "13px",
            fontWeight: 500,
            color: "#1a1a1a",
            lineHeight: 1.35,
          }}
        >
          {this.props.title}
        </span>
        {isFav ? (
          <StarFilled
            style={{ fontSize: "15px", color: "#FAAD14", flexShrink: 0 }}
            onClick={async () => {
              clickstar = true;
              await this.onClickStar(this.props.title);
              this.props.onClickStar();
              clickstar = false;
            }}
          />
        ) : (
          <StarOutlined
            style={{ fontSize: "15px", color: "#d0d0d0", flexShrink: 0 }}
            onClick={async () => {
              clickstar = true;
              await this.onClickStar(this.props.title);
              this.props.onClickStar();
              clickstar = false;
            }}
          />
        )}
      </div>
    );
  }
}

class Reportes extends Component {
  state = {
    reportesFavoritos: [],
  };

  componentDidMount() {
    this.selectReportesFavoritos();
  }

  selectReportesFavoritos() {
    axios
      .post(
        "reportes/selectReportesFavoritos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ reportesFavoritos: [] });
        } else {
          let nuevoArrayFavoritos = [];
          for (const valueFavorito of res.data) {
            if (this.props["permisoAccesoReporte" + valueFavorito.replace(/\s+/g, "")]) {
              nuevoArrayFavoritos.push(valueFavorito);
            }
          }
          this.setState({ reportesFavoritos: nuevoArrayFavoritos });
        }
      });
  }

  displayFavoritos() {
    if (!this.state.reportesFavoritos.length) {
      return (
        <div style={{ textAlign: "center", padding: "60px 20px" }}>
          <StarOutlined
            style={{
              fontSize: "36px",
              color: "#d9d9d9",
              display: "block",
              marginBottom: "14px",
            }}
          />
          <p style={{ margin: 0, fontSize: "14px", fontWeight: 500, color: "#595959" }}>
            Sin reportes favoritos
          </p>
          <p style={{ margin: "6px 0 0", fontSize: "12px", color: "#8c8c8c" }}>
            Marca reportes con ★ para acceder a ellos rápidamente.
          </p>
        </div>
      );
    }

    return (
      <div className="reportes-card-grid" style={{ marginTop: "16px" }}>
        {this.state.reportesFavoritos.map((title) => (
          <CardReportes
            key={title}
            color={REPORT_COLORS[title] || "#00BFD6"}
            onClick={() =>
              this.props.history.push("/panel/reporte" + title.replace(/\s+/g, ""))
            }
            onClickStar={() => this.selectReportesFavoritos()}
            favorito={true}
            title={title}
          />
        ))}
      </div>
    );
  }

  render() {
    const p = this.props;
    const fav = this.state.reportesFavoritos;

    const card = (permFlag, title, path, color) => {
      if (!permFlag) return null;
      return (
        <CardReportes
          key={title}
          color={color}
          onClick={() => p.history.push(path)}
          onClickStar={() => this.selectReportesFavoritos()}
          favorito={fav.find((e) => e === title)}
          title={title}
        />
      );
    };

    return (
      <>
        <PageHeader
          title="Reportes"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div
          style={{
            backgroundColor: "white",
            padding: 20,
            paddingTop: 5,
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
            border: "1px solid rgb(235, 237, 240)",
          }}
        >
          <Tabs defaultActiveKey="1">
            <TabPane tab={<><RiseOutlined /> Todos</>} forceRender key="1">

              {/* ── CREADOR DE REPORTES ── */}
              {p.permisoAccesoReporteCreadorDeReportes && (
                <>
                  <SectionHeader color={COLORS.creador}>Creador de Reportes</SectionHeader>
                  <div className="reportes-card-grid" style={{ marginBottom: "8px" }}>
                    {card(true, "Creador de Reportes", "/panel/creadorDeReportes", COLORS.creador)}
                  </div>
                </>
              )}

              {/* ── VENTAS ── */}
              {p.permisoAccesoReporteVentasGenerales && (
                <>
                  <SectionHeader color={COLORS.ventas}>Reportes de Ventas</SectionHeader>
                  <div className="reportes-card-grid">
                    {card(p.permisoAccesoReporteVentasGenerales,    "Ventas Generales",         "/panel/reporteVentasGenerales",       COLORS.ventas)}
                    {card(p.permisoAccesoReportePedidos,             "Pedidos",                  "/panel/reportePedidos",               COLORS.ventas)}
                    {card(p.permisoAccesoReporteCotizaciones,        "Cotizaciones",             "/panel/reporteCotizaciones",          COLORS.ventas)}
                    {card(p.permisoAccesoReporteVentasFiscales,      "Ventas Fiscales",          "/panel/reporteVentasFiscales",        COLORS.ventas)}
                    {card(p.permisoAccesoReporteInsumosMasVendidos,  "Insumos Más Vendidos",     "/panel/reporteInsumosMasVendidos",    COLORS.ventas)}
                    {card(p.permisoAccesoReporteMargenVentas,        "Margen De Ventas",         "/panel/reporteMargenDeVentas",        COLORS.ventas)}
                    {card(p.permisoAccesoReporteNotasDeCreditoVenta, "Notas De Credito Venta",   "/panel/reporteNotasDeCreditoVenta",   COLORS.ventas)}
                    {card(p.permisoAccesoReporteVentasPorLote,       "Ventas Por Lote",          "/panel/reporteVentasPorLote",         COLORS.ventas)}
                    {card(p.permisoAccesoReporteCotizacionVsVentas,  "Cotizacion Vs Ventas",     "/panel/reporteCotizacionVsVentas",    COLORS.ventas)}
                    {card(p.permisoAccesoReportePedidoVsVentas,      "Pedido Vs Ventas",         "/panel/reportePedidoVsVentas",        COLORS.ventas)}
                  </div>
                </>
              )}

              {/* ── COMPRAS ── */}
              {(p.permisoAccesoReporteComprasGenerales || p.permisoAccesoReporteInsumosYProveedores) && (
                <>
                  <SectionHeader color={COLORS.compras}>Reportes de Compras</SectionHeader>
                  <div className="reportes-card-grid">
                    {card(p.permisoAccesoReporteComprasGenerales,    "Compras Generales",        "/panel/reporteComprasGenerales",      COLORS.compras)}
                    {card(p.permisoAccesoReporteOrdenesDeCompra,     "Ordenes de Compra",        "/panel/ReporteOrdenesDeCompra",       COLORS.compras)}
                    {card(p.permisoAccesoReporteRequisiciones,       "Requisiciones",            "/panel/ReporteRequisiciones",         COLORS.compras)}
                    {card(p.permisoAccesoReporteInsumosMasComprados, "Insumos Más Comprados",    "/panel/reporteInsumosMasComprados",   COLORS.compras)}
                    {card(p.permisoAccesoReporteCostosInternos,      "Costos Internos",          "/panel/reporteCostosInternos",        COLORS.compras)}
                    {card(p.permisoAccesoReporteCostosInternos,      "Conciliacion Costos Internos", "/panel/reporteConciliacionCostosInternos", COLORS.compras)}
                    {card(p.permisoAccesoReporteComodatos,           "Comodatos",                "/panel/reporteComodatos",             COLORS.compras)}
                    {card(p.permisoAccesoReporteNotasDeCreditoCompra, "Notas De Credito Compra",  "/panel/reporteNotasDeCreditoCompra",  COLORS.compras)}
                    {card(p.permisoAccesoReporteInsumosYProveedores,  "Insumos Y Proveedores",    "/panel/reporteInsumosYProveedores",   COLORS.compras)}
                  </div>
                </>
              )}

              {/* ── INVENTARIO ── */}
              {(p.permisoAccesoReporteInventarioTotal || p.permisoAccesoReporteCostoInventario || p.permisoAccesoReporteCostoVsUltimaCompra || p.permisoAccesoReporteCostosPorInsumo || p.permisoAccesoReporteInsumosYEquivalencias || p.permisoAccesoReporteInsumosPendientes || p.permisoAccesoReporteRecepcionesOrdenDeCompra || p.permisoAccesoReporteLotes) && (
                <>
                  <SectionHeader color={COLORS.inventario}>Reportes de Inventario</SectionHeader>
                  <div className="reportes-card-grid">
                    {card(p.permisoAccesoReporteInventarioTotal,              "Inventario Total",           "/panel/reporteInventarioTotal",              COLORS.inventario)}
                    {card(p.permisoAccesoReporteCostoInventario,              "Costo Inventario",           "/panel/reporteCostoInventario",              COLORS.inventario)}
                    {card(p.permisoAccesoReporteCostoVsUltimaCompra,          "Costo Vs Ultima Compra",     "/panel/reporteCostoVsUltimaCompra",          COLORS.inventario)}
                    {card(p.permisoAccesoReporteCostosPorInsumo,              "Costos Por Insumo",          "/panel/reporteCostosPorInsumo",              COLORS.inventario)}
                    {card(p.permisoAccesoReporteInsumosYEquivalencias,        "Insumos Y Equivalencias",    "/panel/reporteInsumosYEquivalencias",        COLORS.inventario)}
                    {card(p.permisoAccesoReporteLotes,                       "Reporte De Lotes",           "/panel/reporteLotes",                        COLORS.inventario)}
                    {card(p.permisoAccesoReporteCostoProduccion,              "Costo Produccion",           "/panel/reporteCostoProduccion",              COLORS.inventario)}
                    {card(p.permisoAccesoReporteEntradasSalidas,              "Entradas Y Salidas",         "/panel/reporteEntradasSalidas",              COLORS.inventario)}
                    {card(p.permisoAccesoReporteEntradasSalidasDetallado,     "E. y S. Detallado",          "/panel/reporteEntradasSalidasDetallado",     COLORS.inventario)}
                    {card(p.permisoAccesoReporteInsumosNoInventariables,      "Insumos No Inventariables",  "/panel/reporteInsumosNoInventariables",      COLORS.inventario)}
                    {card(p.permisoAccesoReporteResumenEntradasYSalidas,      "Resumen E. Y S.",            "/panel/reporteResumenEntradasYSalidas",      COLORS.inventario)}
                    {card(p.permisoAccesoReporteActividadEtapas,              "Actividad Etapas",           "/panel/reporteActividadEtapas",              COLORS.inventario)}
                    {card(p.permisoAccesoReporteTraspasoEntreAlmacenes,       "Traspaso Entre Almacenes",   "/panel/reporteTraspasoEntreAlmacenes",       COLORS.inventario)}
                    {card(p.permisoAccesoReporteCostoTotalProyecto,           "Costo Total Proyecto",       "/panel/reporteCostoTotalProyecto",           COLORS.inventario)}
                    {card(p.permisoAccesoReporteTaxidermia,                   "Taxidermia",                 "/panel/reporteTaxidermia",                   COLORS.inventario)}
                    {card(p.permisoAccesoReporteInsumosPendientes,             "Insumos Pendientes",         "/panel/reporteInsumosPendientes",            COLORS.inventario)}
                    {card(p.permisoAccesoReporteRecepcionesOrdenDeCompra,      "Recepciones Orden de Compra", "/panel/reporteRecepcionesOrdenDeCompra",    COLORS.inventario)}
                  </div>
                </>
              )}

              {/* ── ADMINISTRATIVOS ── */}
              {(p.permisoAccesoReporteCuentasPorCobrar || p.permisoAccesoReporteCuentasPorPagar) && (
                <>
                  <SectionHeader color={COLORS.administrativos}>Reportes Administrativos</SectionHeader>
                  <div className="reportes-card-grid">
                    {card(p.permisoAccesoReporteCuentasPorCobrar,          "Cuentas Por Cobrar",                  "/panel/reporteCuentasPorCobrar",          COLORS.administrativos)}
                    {card(p.permisoAccesoReporteCuentasPorPagar,           "Cuentas Por Pagar",                   "/panel/reporteCuentasPorPagar",           COLORS.administrativos)}
                    {card(p.permisoAccesoReportePagos,                     "Pagos",                               "/panel/reportePagos",                     COLORS.administrativos)}
                    {card(p.permisoAccesoReporteIngresos,                  "Ingresos",                            "/panel/reporteIngresos",                  COLORS.administrativos)}
                    {card(p.permisoAccesoReportePresupuestos,              "Presupuestos",                        "/panel/reportePresupuestos",              COLORS.administrativos)}
                    {card(p.permisoAccesoReporteReposicionCajaChica,       "Reposicion Caja Chica",               "/panel/reporteReposicionCajaChica",       COLORS.administrativos)}
                    {card(p.permisoAccesoReporteCuentasPorCobrarAgrupado,  "Cuentas Por Cobrar Agrupado",         "/panel/reporteCuentasPorCobrarAgrupado",  COLORS.administrativos)}
                    {card(p.permisoAccesoReporteCuentasPorPagarAgrupado,   "Cuentas Por Pagar Agrupado",          "/panel/reporteCuentasPorPagarAgrupado",   COLORS.administrativos)}
                    {card(p.permisoAccesoReporteCuentasCliente,            "Cuentas Cliente",                     "/panel/reporteCuentasCliente",            COLORS.administrativos)}
                    {card(p.permisoAccesoReporteFacturacion,               "Facturacion",                         "/panel/reporteFacturacion",               COLORS.administrativos)}
                    {card(p.permisoAccesoReporteCobranzaPorSemana,         "Cobranza Por Semana",                 "/panel/reporteCobranzaPorSemana",         COLORS.administrativos)}
                    {card(p.permisoAccesoReportePagosAProveedores,         "Pagos a proveedores",                 "/panel/reportePagosAProveedores",         COLORS.administrativos)}
                    {card(p.permisoAccesoReporteXml,                       "Reporte XML",                         "/panel/reporteXml",                       COLORS.administrativos)}
                  </div>
                </>
              )}

              {/* ── FINANCIEROS ── */}
              {(p.permisoAccesoReporteEstadoDePosicionFinanciera ||
                p.permisoAccesoReporteEstadoDeResultados ||
                p.permisoAccesoReporteEstadoDeResultadosPorPeriodo ||
                p.permisoAccesoReporteEstadoDeCuenta ||
                p.permisoAccesoReporteBalanzaDeComprabacion ||
                p.permisoAccesoReporteFlujoDeEfectivo ||
                p.permisoAccesoReporteFlujoDeEfectivoDiario ||
                p.permisoAccesoReporteFlujoDeTesorefia) && (
                <>
                  <SectionHeader color={COLORS.financieros}>Reportes Financieros</SectionHeader>
                  <div className="reportes-card-grid">
                    {card(p.permisoAccesoReporteEstadoDePosicionFinanciera,   "Estado De Posicion Financiera",        "/panel/reporteEstadoDePosicionFinanciera",   COLORS.financieros)}
                    {card(p.permisoAccesoReporteEstadoDeResultados,           "Estado De Resultados",                 "/panel/reporteEstadoDeResultados",           COLORS.financieros)}
                    {card(p.permisoAccesoReporteEstadoDeResultadosPorPeriodo, "Estado De Resultados Por Periodo",     "/panel/reporteEstadoDeResultadosPorPeriodo", COLORS.financieros)}
                    {card(p.permisoAccesoReporteEstadoDeCuenta,               "Estado De Cuenta",                     "/panel/reporteEstadoDeCuenta",               COLORS.financieros)}
                    {card(p.permisoAccesoReporteBalanzaDeComprabacion,        "Balanza De Comprobacion",              "/panel/reporteBalanzaDeComprobacion",        COLORS.financieros)}
                    {card(p.permisoAccesoReporteFlujoDeEfectivo,              "Flujo De Efectivo",                    "/panel/reporteFlujoDeEfectivo",              COLORS.financieros)}
                    {card(p.permisoAccesoReporteFlujoDeEfectivoPresupuestado, "Flujo De Efectivo Presupuestado",      "/panel/reporteFlujoDeEfectivoPresupuestado", COLORS.financieros)}
                    {card(p.permisoAccesoReporteFlujoDeEfectivoDiario,        "Flujo De Efectivo Diario",             "/panel/reporteFlujoDeEfectivoDiario",        COLORS.financieros)}
                    {card(p.permisoAccesoReporteLibroDiario,                  "Libro Diario",                         "/panel/reporteLibroDiario",                  COLORS.financieros)}
                    {card(p.permisoAccesoReporteLibroMayor,                   "Libro Mayor",                          "/panel/reporteLibroMayor",                   COLORS.financieros)}
                    {card(p.permisoAccesoReporteFlujoDeTesorefia,             "Flujo De Tesorería",                   "/panel/reporteFlujoDeTesorefia",             COLORS.financieros)}
                  </div>
                </>
              )}

              {/* ── CALIDAD ── */}
              {p.permisoAccesoReporteCalidad && (
                <>
                  <SectionHeader color={COLORS.calidad}>Reportes de Calidad</SectionHeader>
                  <div className="reportes-card-grid">
                    {card(true, "Reporte Calidad", "/panel/reporteCalidad", COLORS.calidad)}
                  </div>
                </>
              )}

              {/* ── FISCALES ── */}
              <SectionHeader color={COLORS.fiscales}>Reportes Fiscales</SectionHeader>
              <div className="reportes-card-grid" style={{ marginBottom: "16px" }}>
                {card(p.permisoAccesoReporteDIOT,                           "Reporte DIOT",                                        "/panel/reporteDIOT",                                              COLORS.fiscales)}
                {card(p.permisoAccesoReporteBalanzaContabilidadElectronica, "Balanza De Comprobacion - Contabilidad Electronica",  "/panel/reporteBalanzaDeComprobacionContabilidadElectronica",      COLORS.fiscales)}
                {card(p.permisoAccesoReporteIVA,                            "Reporte IVA",                                         "/panel/reporteIVA",                                               COLORS.fiscales)}
                {card(p.permisoAccesoReporteRetencionesDeCompras,           "Retenciones De Compras",                              "/panel/reporteRetencionesDeCompras",                              COLORS.fiscales)}
                {card(p.permisoAccesoReporteRetencionesDeVentas,            "Retenciones De Ventas",                               "/panel/reporteRetencionesDeVentas",                               COLORS.fiscales)}
                {/* El titulo sin espacios tiene que coincidir con el sufijo de la prop
                    y con el segmento de la ruta: Favoritos reconstruye las dos a partir
                    del titulo (lineas 251 y 289). Por eso van sin acentos. */}
                {card(p.permisoAccesoReporteConciliacionFacturasPagos,      "Conciliacion Facturas Pagos",                         "/panel/reporteConciliacionFacturasPagos",                         COLORS.fiscales)}
                {card(p.permisoAccesoReporteFacturasGlobales,               "Facturas Globales",                                   "/panel/reporteFacturasGlobales",                                  COLORS.fiscales)}
              </div>

              {/* ── ESCUELA ── */}
              {p.escuela && (
                <>
                  <SectionHeader color={COLORS.escuela}>Reportes de Escuela</SectionHeader>
                  <div className="reportes-card-grid">
                    {card(true, "Alumnos Y Ventas", "/panel/reporteAlumnosYVentas", COLORS.escuela)}
                    {card(true, "Referencias De Pago", "/panel/reporteReferenciasDePago", COLORS.escuela)}
                  </div>
                </>
              )}

              {/* ── RECURSOS HUMANOS ── */}
              {(p.permisoAccesoReporteEmpleados || p.permisoAccesoReporteRegistroEmpleados) && (
                <>
                  <SectionHeader color={COLORS.recursosHumanos}>Reportes de Recursos Humanos</SectionHeader>
                  <div className="reportes-card-grid">
                    {card(p.permisoAccesoReporteEmpleados,         "Reporte De Empleados",  "/panel/reporteEmpleados",         COLORS.recursosHumanos)}
                    {card(p.permisoAccesoReporteRegistroEmpleados, "Registro De Empleados", "/panel/reporteRegistroEmpleados", COLORS.recursosHumanos)}
                  </div>
                </>
              )}

            </TabPane>
            <TabPane tab={<><StarFilled /> Favoritos</>} key="2">
              {this.displayFavoritos()}
            </TabPane>
          </Tabs>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const permisos = state.user.permisos;
  const tipo = state.user.tipo;
  const { taxidermia, moduloCalidad, escuela } = state.empresa;

  const perm = (id) => permisos.find((v) => v.permisoId.toString() === id)?.activado;

  // Si el nuevo permiso existe en el array → usa su valor.
  // Si no existe → usa el fallback (regla anterior).
  const permWithFallback = (newId, fallback) => {
    if (newId === "6a22416681aa896b004c9bf1"){
      console.log(permisos)
    }
    if (tipo === 0) return true;
    const found = permisos.find((v) => v.permisoId.toString() === newId);
    if (found !== undefined) return !!found.activado;
    return !!fallback;
  };

  // Permisos base (usados como fallback y para guards de sección)
  const _vg  = perm("6489ee6f6ebb47b9440df7b0"); // Ventas Generales
  const _cg  = perm("6489ef026ebb47b9440df7b1"); // Compras Generales
  const _it  = perm("6489ef186ebb47b9440df7b2"); // Inventario Total
  const _ci  = perm("6489ef3a6ebb47b9440df7b3"); // Costo Inventario
  const _cpc = perm("6489ef556ebb47b9440df7b4"); // Cuentas Por Cobrar
  const _cpp = perm("6489ef796ebb47b9440df7b5"); // Cuentas Por Pagar
  const _bc  = perm("6489efeb6ebb47b9440df7b9"); // Balanza Comprobación
  const _cp  = perm("67508d79798d4e0043687235"); // Costo Producción

  return {
    taxidermia,
    moduloCalidad,
    escuela,

    permisoAccesoReporteCreadorDeReportes: permWithFallback("6a74d41feed3067780a5add6"),

    // ── Permisos umbrella (mantienen guards de sección y backward compat) ──
    permisoAccesoReporteVentasGenerales:              tipo === 0 || _vg,
    permisoAccesoReporteComprasGenerales:             tipo === 0 || _cg,
    permisoAccesoReporteInventarioTotal:              tipo === 0 || _it,
    permisoAccesoReporteCostoInventario:              tipo === 0 || _ci,
    permisoAccesoReporteCuentasPorCobrar:             tipo === 0 || _cpc,
    permisoAccesoReporteCuentasPorPagar:              tipo === 0 || _cpp,
    permisoAccesoReporteEstadoDePosicionFinanciera:   tipo === 0 || perm("6489ef8f6ebb47b9440df7b6"),
    permisoAccesoReporteEstadoDeResultados:           tipo === 0 || perm("6489efb16ebb47b9440df7b7"),
    // Mientras no exista el documento Permiso propio, el id placeholder nunca
    // hace match y manda el permiso del Estado de Resultados. Al crearlo,
    // sustituir los 24 ceros aqui y en Panel.js.
    permisoAccesoReporteEstadoDeResultadosPorPeriodo: permWithFallback("000000000000000000000000", perm("6489efb16ebb47b9440df7b7")),
    permisoAccesoReporteEstadoDeCuenta:               tipo === 0 || perm("6489efd56ebb47b9440df7b8"),
    permisoAccesoReporteBalanzaDeComprabacion:        tipo === 0 || _bc,
    permisoAccesoReporteFlujoDeEfectivo:              tipo === 0 || perm("6489f00b6ebb47b9440df7ba"),
    permisoAccesoReporteFlujoDeEfectivoPresupuestado: tipo === 0 || perm("6494a5a018c09185602b4aaa"),
    // Mientras no exista el documento Permiso propio, el id placeholder nunca hace
    // match y manda el permiso del Flujo De Efectivo. Al crearlo, sustituir los 24
    // ceros aqui y en Panel.js.
    permisoAccesoReporteFlujoDeEfectivoDiario:        permWithFallback("000000000000000000000000", perm("6489f00b6ebb47b9440df7ba")),
    permisoAccesoReporteFlujoDeTesorefia:             permWithFallback("6a261b2bbab6af42044ba553"),
    permisoAccesoReporteInventarioMaxYMin:            tipo === 0 || perm("67508da0798d4e0043687236"),
    permisoAccesoReporteLibroDiario:                  tipo === 0 || perm("67508c87798d4e0043687230"),
    permisoAccesoReportePagos:                        tipo === 0 || perm("67508d11798d4e0043687231"),
    permisoAccesoReporteIngresos:                     tipo === 0 || perm("67508d25798d4e0043687232"),
    permisoAccesoReportePresupuestos:                 tipo === 0 || perm("67508d38798d4e0043687233"),
    permisoAccesoReporteReposicionCajaChica:          tipo === 0 || perm("67508d4f798d4e0043687234"),
    permisoAccesoReporteCostoProduccion:              tipo === 0 || _cp,
    permisoAccesoReporteInsumosMasComprados:          tipo === 0 || perm("69d443d0d1cda4af6dfca7c9"),
    permisoAccesoReporteCostosInternos:               tipo === 0 || perm("6a28f7850e156f1486dbb1b9"),
    permisoAccesoReporteComodatos:                    tipo === 0 || perm("6a624ed2f04f1ced48a77414"),
    permisoAccesoReporteNotasDeCreditoCompra:          tipo === 0 || perm("6a62ab9cf04f1ced48a85550"),
    // "Reporte Insumos - proveedores" (numero 70). Fallback a Compras
    // Generales mientras el permiso se asigna. El id debe ser IDENTICO al de
    // Panel.js, o la tarjeta y la ruta pueden discrepar.
    permisoAccesoReporteInsumosYProveedores:          permWithFallback("6ab095a134110875ce269c73", _cg),
    permisoAccesoReporteInsumosMasVendidos:           tipo === 0 || perm("69d44413d1cda4af6dfca7fa"),
    permisoAccesoReporteMargenVentas:                 tipo === 0 || perm("6a750cb96dd22e624b4b6f53"),

    // ── Ventas: nuevos permisos individuales, fallback a Ventas Generales ──
    permisoAccesoReportePedidos:             permWithFallback("6a223fc181aa896b004c9bde", _vg),
    permisoAccesoReporteCotizaciones:        permWithFallback("6a223fd481aa896b004c9bdf", _vg),
    permisoAccesoReporteVentasFiscales:      permWithFallback("6a223ffd81aa896b004c9be0", _vg),
    permisoAccesoReporteNotasDeCreditoVenta: permWithFallback("6a22401a81aa896b004c9be1", _vg),
    // Sin Permiso propio en la base: se rige por Ventas Generales. Si algun dia se siembra uno,
    // basta cambiar esta linea por permWithFallback("<nuevoId>", _vg).
    permisoAccesoReporteVentasPorLote:       tipo === 0 || _vg,
    permisoAccesoReporteCotizacionVsVentas:  permWithFallback("6ab095ee7a54c4287414586d", _vg),
    permisoAccesoReportePedidoVsVentas:      permWithFallback("6ab095fb34110875ce269c74", _vg),

    // ── Compras: nuevos permisos, fallback = siempre visible (antes sin permiso) ──
    permisoAccesoReporteOrdenesDeCompra: permWithFallback("6a22403781aa896b004c9be2", true),
    permisoAccesoReporteRequisiciones:   permWithFallback("6a22404781aa896b004c9be3", true),

    // ── Inventario: nuevos permisos individuales, fallback a Inventario Total ──
    permisoAccesoReporteEntradasSalidas:          permWithFallback("6a22407781aa896b004c9be4", _it),
    permisoAccesoReporteEntradasSalidasDetallado: permWithFallback("6a22408681aa896b004c9be5", _it),
    permisoAccesoReporteInsumosNoInventariables:  permWithFallback("6a4d51d96d560a3eb08fd030", _it),
    permisoAccesoReporteResumenEntradasYSalidas:  permWithFallback("6a22409381aa896b004c9be6", _it),
    permisoAccesoReporteTraspasoEntreAlmacenes:   permWithFallback("6a2240a281aa896b004c9be7", _it),
    permisoAccesoReporteCostoTotalProyecto:       permWithFallback("6a2240ba81aa896b004c9be8", true),
    permisoAccesoReporteActividadEtapas:          permWithFallback("6a2240c381aa896b004c9be9", _cp && taxidermia),
    permisoAccesoReporteTaxidermia:               permWithFallback("6a2240d081aa896b004c9bea", taxidermia),
    permisoAccesoReporteInsumosPendientes:        permWithFallback("6a540aa45d201c0668caa342"),
    permisoAccesoReporteRecepcionesOrdenDeCompra: permWithFallback("6a6a2c15024d2c4c1a16aee9"),
    permisoAccesoReporteLotes:                    permWithFallback("6a75229ca0ca425474d8ca8d"),
    // Placeholder: al crear el documento Permiso, sustituir los 24 ceros aqui y
    // en Panel.js. Mientras no exista, cuelga de Costo Inventario.
    permisoAccesoReporteCostoVsUltimaCompra:      permWithFallback("6a9c9d14e58adfd453fbccb8", _ci),
    // Permiso "Reporte Insumos" (numero 120). Ya existe en la BD, asi que no
    // lleva fallback: sin el permiso no se ve la tarjeta.
    permisoAccesoReporteInsumosYEquivalencias:    permWithFallback("6aa34afa3d2dd25d76ad48a2"),
    // Permiso "Costos Por Insumo" (numero 130). Ya existe en la BD, asi que no
    // lleva fallback: sin el permiso no se ve la tarjeta.
    permisoAccesoReporteCostosPorInsumo:          permWithFallback("6ab3ee2de5f258ab475da861"),

    // ── Administrativos ──
    permisoAccesoReporteCuentasPorCobrarAgrupado: permWithFallback("6a2240ed81aa896b004c9beb", _cpc),
    permisoAccesoReporteCuentasPorPagarAgrupado:  permWithFallback("6a2240f781aa896b004c9bec", true),
    permisoAccesoReporteCuentasCliente:           permWithFallback("6a22410581aa896b004c9bed", _cpc),
    permisoAccesoReporteFacturacion:              permWithFallback("6a2241d581aa896b004c9bf6", true),
    permisoAccesoReporteCobranzaPorSemana:        permWithFallback("6a2241c481aa896b004c9bf5", true),
    permisoAccesoReportePagosAProveedores:        permWithFallback("6a22411381aa896b004c9bee", true),
    permisoAccesoReporteXml:                      permWithFallback("6a22411d81aa896b004c9bef", true),

    // ── Financieros ──
    // Libro Mayor: nuevo ID, fallback al ID viejo (67509100...)
    permisoAccesoReporteLibroMayor: permWithFallback("6a22413b81aa896b004c9bf0", perm("67509100798d4e0043687260")),

    // ── Fiscales ──
    permisoAccesoReporteDIOT:                         permWithFallback("6a22416681aa896b004c9bf1"),
    permisoAccesoReporteBalanzaContabilidadElectronica: permWithFallback("6a22417981aa896b004c9bf2", _bc),
    permisoAccesoReporteIVA:                          permWithFallback("6a28f7400e156f1486dbb1b8"),
    permisoAccesoReporteRetencionesDeCompras:          permWithFallback("6a84ebf2a0715801e4c6405b"),
    permisoAccesoReporteRetencionesDeVentas:           permWithFallback("6a84ebfca0715801e4c6405c"),
    permisoAccesoReporteConciliacionFacturasPagos:     permWithFallback("6a985be44c25993f2f8c243f"),
    permisoAccesoReporteFacturasGlobales:              permWithFallback("6a985c013de76a7325a6a2a7"),

    // ── Calidad ──
    permisoAccesoReporteCalidad: permWithFallback("6a2241b781aa896b004c9bf4", moduloCalidad),

    // ── Recursos Humanos ──
    permisoAccesoReporteEmpleados:         permWithFallback("6a695ae449a8383de2bd9857", true),
    permisoAccesoReporteRegistroEmpleados: permWithFallback("6a695b0549a8383de2bd9858", true),

    // ── Escuela ──
    // No es un permiso: el reporte no tiene ninguno todavia y depende solo del
    // modulo. Va con este nombre porque el filtro de favoritos busca
    // props["permisoAccesoReporte" + titulo sin espacios] y si no existe, el
    // reporte se cae de la pestaña Favoritos aunque este marcado con estrella.
    permisoAccesoReporteAlumnosYVentas: escuela,
    permisoAccesoReporteReferenciasDePago: escuela,
  };
};

export default connect(mapStateToProps)(Reportes);
